"use strict";var e=require("tslib"),r=require("@mui/material/styles");module.exports=function(t){for(var a=[],i=1;i<arguments.length;i++)a[i-1]=arguments[i];return r.createTheme.apply(void 0,e.__spreadArray([e.__assign({},t)],a))};
